var __jsx = React.createElement;
import React from 'react';
import CartRCAProduct from '../../cart/items/CartRCAProduct';
import Col from 'react-bootstrap/Col';

var RCAPage = function RCAPage(props) {
  var list = props.list,
      addToCart = props.addToCart,
      hideExpired = props.hideExpired;
  return __jsx(Col, {
    lg: 8,
    className: "mx-auto"
  }, list.map(function (rca) {
    return hideExpired && !rca.isAvailable ? '' : __jsx(CartRCAProduct, {
      key: rca.id,
      product: rca,
      editOption: "no",
      requestApiData: "yes",
      addToCart: addToCart,
      hideExpired: hideExpired
    });
  }));
};

export default RCAPage;